import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { handleChange } from 'lib/stores/formStore';
import { formatIdFromName, camelize, sortOptions } from 'lib/utility';
import { getCommonLocale } from 'lib/i18n';
import useFormField from 'lib/hooks/useFormField';

import FormLabel from './FormLabel';

const FormBadgeMultiSelect = ({ name, label, id, options, sort = true, required = false }) => {
  const [value] = useFormField(name);
  const sortedOptions = sort ? sortOptions(options) : options;
  const badgeClass = optionValue => clsx(
    'badge badge-lg me-1 mb-1 clickable',
    value.includes(optionValue) ? 'badge-selected' : 'badge-not-selected',
  );

  const select = optionValue => {
    const selected = [...value];

    if (selected.includes(optionValue)) {
      selected.splice(selected.findIndex(val => val === optionValue), 1);
    } else {
      selected.push(optionValue);
    }

    handleChange(selected, name);
  };

  const keyPressSelect = (e, optionValue) => {
    e.preventDefault();

    if (e.code !== 'Enter' && e.code !== 'NumpadEnter' && e.code !== 'Space') return;

    select(optionValue);
  };

  return (
    <div className="mb-3">
      <FormLabel id={id || formatIdFromName(name)} label={label} required={required} />
      <p className="form-footnote">
        <small><FormattedMessage {...getCommonLocale('select_badges')} /></small>
      </p>
      <div role="listbox" id={id || formatIdFromName(name)} aria-labelledby={`${id || formatIdFromName(name)}Label`}>
        {sortedOptions.map(([optionValue, optionLabel, optionTestId]) => (
          <span
            role="option"
            key={optionValue}
            className={badgeClass(optionValue)}
            onClick={() => select(optionValue)}
            onKeyPress={e => keyPressSelect(e, optionValue)}
            aria-selected={value.includes(optionValue)}
            data-testid={`${formatIdFromName(name)}_${camelize(optionTestId || optionValue)}`}
            tabIndex={0}
          >
            {optionLabel}
          </span>
        ))}
      </div>
    </div>
  );
};

export default FormBadgeMultiSelect;
